(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cenvanta-pet-story"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('cenvanta-motion')){
customElements.define('cenvanta-motion',class extends HTMLElement{
 connectedCallback(){
  if(this._abort)return;
  this._abort=new AbortController();const signal=this._abort.signal;
  this.frames=[...this.querySelectorAll('.cm-scene')];this.track=this.querySelector('.cm-track');
  this.captionNode=this.querySelector('.cm-active-title');this.link=this.querySelector('.cm-link');this.bar=this.querySelector('.cm-progress span');
  this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.p=0;this.target=0;this.raf=0;this.last=0;
  const setup=()=>{
   cancelAnimationFrame(this.raf);this.raf=0;
   const enabled=!this.motion.matches&&this.frames.length>1;
   this.classList.toggle('cm-ready',enabled);
   if(!enabled){this.frames.forEach(f=>{f.style.opacity='';f.style.visibility='';f.removeAttribute('aria-hidden')});if(this.link){this.link.style.opacity='1';this.link.style.visibility='visible';this.link.removeAttribute('tabindex')}return;}
   this.update(true);
  };
  this.motion.addEventListener('change',setup,{signal});
  window.addEventListener('scroll',()=>this.update(),{passive:true,signal});
  window.addEventListener('resize',()=>this.update(true),{passive:true,signal});
  this.addEventListener('shopify:block:select',e=>{
   const index=this.frames.indexOf(e.target.closest('.cm-scene'));if(index<0||!this.classList.contains('cm-ready'))return;
   const top=this.track.getBoundingClientRect().top+scrollY;const offset=parseFloat(getComputedStyle(this).getPropertyValue('--offset'))||0;
   window.scrollTo({top:top-offset+(this.track.offsetHeight-this.querySelector('.cm-pin').offsetHeight)*index/(this.frames.length-1),behavior:'instant'});
  },{signal});
  this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.querySelectorAll('img').forEach(i=>i.loading='eager');this.observer.disconnect()}},{rootMargin:'600px'});this.observer.observe(this);
  setup();
 }
 update(immediate=false){
  if(!this.classList.contains('cm-ready'))return;
  const offset=parseFloat(getComputedStyle(this).getPropertyValue('--offset'))||0;
  const distance=this.track.offsetHeight-this.querySelector('.cm-pin').offsetHeight;
  this.target=Math.max(0,Math.min(1,(offset-this.track.getBoundingClientRect().top)/Math.max(1,distance)));
  if(immediate){this.p=this.target;this.paint();return}
  if(!this.raf){this.last=performance.now();this.raf=requestAnimationFrame(t=>this.tick(t))}
 }
 tick(t){
  this.raf=0;const tau=Math.max(.05,Number(this.dataset.scrub)||.16)*1000;
  this.p+=(this.target-this.p)*(1-Math.exp(-(t-this.last)/tau));this.last=t;
  if(Math.abs(this.p-this.target)<.0002)this.p=this.target;
  this.paint();if(this.p!==this.target)this.raf=requestAnimationFrame(t=>this.tick(t));
 }
 paint(){
  const x=this.p*(this.frames.length-1),a=Math.floor(x),mix=Math.max(0,Math.min(1,(x-a-.65)/.35));
  const active=Math.min(this.frames.length-1,a+(mix>=.5?1:0));
  this.frames.forEach((f,i)=>{const alpha=i===a?1-mix:i===a+1?mix:0;f.style.opacity=alpha;f.style.visibility=alpha>0?'visible':'hidden';f.setAttribute('aria-hidden',String(i!==active))});
  if(this.captionNode){this.captionNode.textContent=this.frames[active].dataset.title;this.captionNode.style.opacity=1-Math.sin(mix*Math.PI)*.8}
  if(this.bar)this.bar.style.transform='scaleX('+this.p+')';
  if(this.link){const show=this.p>=.9;this.link.style.opacity=show?'1':'0';this.link.style.visibility=show?'visible':'hidden';this.link.tabIndex=show?0:-1}
 }
 disconnectedCallback(){this._abort?.abort();this._abort=null;this.observer?.disconnect();cancelAnimationFrame(this.raf)}
});}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cenvanta-product-triangle"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sections = document.querySelectorAll('[data-cv-triangle]');
  sections.forEach((section) => {
    const products = section.querySelectorAll('.cv-product');
    if (!('IntersectionObserver' in window)) {
      products.forEach((product) => product.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });
    products.forEach((product) => observer.observe(product));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cenvanta-scroll-expansion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      if (section.dataset.cvReady) return;
      section.dataset.cvReady = '1';
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      var video = section.querySelector('video');
      var soundButton = section.querySelector('.cv-scroll-expand__sound');
      if (video && soundButton) {
        soundButton.addEventListener('click', function () {
          video.muted = !video.muted;
          if (!video.muted) {
            video.volume = 1;
            video.play().catch(function () {});
          }
          soundButton.setAttribute('aria-pressed', String(!video.muted));
          soundButton.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Mute video');
          soundButton.textContent = video.muted ? '🔇 Sound off' : '🔊 Sound on';
        });
      }
      var ticking = false;
      function render() {
        ticking = false;
        if (reduced.matches) return;
        var rect = section.getBoundingClientRect();
        var distance = Math.max(1, rect.height - window.innerHeight);
        var progress = Math.max(0, Math.min(1, -rect.top / distance));
        var start = Math.min(280, window.innerWidth * .56);
        var end = Math.min(window.innerWidth * (window.innerWidth < 750 ? .94 : .82), window.innerHeight * .78, 780);
        section.style.setProperty('--cv-progress', progress.toFixed(3));
        section.style.setProperty('--cv-media-size', Math.round(start + (end - start) * progress) + 'px');
      }
      function update() {
        if (!ticking) { ticking = true; requestAnimationFrame(render); }
      }
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
      if (video && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) video.play().catch(function () {});
          else video.pause();
        }, { threshold: .1 });
        observer.observe(section);
      }
    }
    function mount() { document.querySelectorAll('[data-cv-scroll-expand]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();
    document.addEventListener('shopify:section:load', mount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
